import React from "react";
import {
  NavbarContainer,
  Left,
  LogoContainer,
  LogoText,
  LogoTextItalic,
  NavOptions,
  ContactInfo,
  Right,
} from "./Navbar.css";

const Navbar = () => {
  const scrollToSection = (e, sectionId, offset) => {
    e.preventDefault();
    const section = document.getElementById(sectionId);
    if (section) {
      const y =
        section.getBoundingClientRect().top + window.pageYOffset + offset;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };
  return (
    <NavbarContainer>
      <Left>
        <LogoContainer>
          <LogoText>Wolnik</LogoText>
          <LogoTextItalic>Optyk</LogoTextItalic>
        </LogoContainer>
        <NavOptions>
          <a href="#oferty" onClick={(e) => scrollToSection(e, "oferta", -80)}>
            oferta
          </a>
          <a
            href="#badania"
            onClick={(e) => scrollToSection(e, "pytania", -40)}
          >
            badania
          </a>
          <a
            href="#machine"
            onClick={(e) => scrollToSection(e, "machine", -180)}
          >
            diagnostyka
          </a>
          <a
            href="#kontakty"
            onClick={(e) => scrollToSection(e, "kontakt", -80)}
          >
            kontakt
          </a>
        </NavOptions>
      </Left>
      <Right>
        <ContactInfo>Umów wizytę: +48 698 589 043</ContactInfo>
      </Right>
    </NavbarContainer>
  );
};

export default Navbar;
